import { Breadcrumbs } from "@/components";
import AudienceIndicator from "@/components/AudienceIndicator/AudienceIndicator";
import type { Crumb } from "../Breadcrumbs/types";
import type { Props } from "./types";

export default function BreadcrumbsWithAudience({
	crumbs,
	crumbsData,
	audienceData,
	removeLastCrumb = true,
}: Props) {
	const ___crumbs = crumbsData
		?.filter((cd) => cd.type === "link")
		.map(
			(cd) =>
				({
					name: cd.label,
					path: cd.path,
					icon: cd.icon ? `${process.env.SRP_ROOT}${cd.icon}` : null,
				}) as Crumb,
		);
	const __crumbs = crumbs ?? ___crumbs ?? [];
	return (
		<Breadcrumbs crumbs={__crumbs} removeLastCrumb={removeLastCrumb}>
			{audienceData && (
				<AudienceIndicator
					url={audienceData.url}
					label={audienceData.name}
					src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${audienceData.code}.svg`}
				/>
			)}
		</Breadcrumbs>
	);
}
